// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file nodebase/v1/admin.proto (package nodebase.v1, syntax proto3)
/* eslint-disable */

import { AdminService } from "./admin_pb";

/**
 * @generated from rpc nodebase.v1.AdminService.AdminListServices
 */
export const adminListServices = AdminService.method.adminListServices;

/**
 * @generated from rpc nodebase.v1.AdminService.AdminInspectWorkerVM
 */
export const adminInspectWorkerVM = AdminService.method.adminInspectWorkerVM;

/**
 * @generated from rpc nodebase.v1.AdminService.AdminManageWorkerVM
 */
export const adminManageWorkerVM = AdminService.method.adminManageWorkerVM;

/**
 * @generated from rpc nodebase.v1.AdminService.AdminListAccounts
 */
export const adminListAccounts = AdminService.method.adminListAccounts;

/**
 * @generated from rpc nodebase.v1.AdminService.AdminSetAccountCohorts
 */
export const adminSetAccountCohorts = AdminService.method.adminSetAccountCohorts;

/**
 * @generated from rpc nodebase.v1.AdminService.AdminListFeatureRollouts
 */
export const adminListFeatureRollouts = AdminService.method.adminListFeatureRollouts;

/**
 * @generated from rpc nodebase.v1.AdminService.AdminSetFeatureRollout
 */
export const adminSetFeatureRollout = AdminService.method.adminSetFeatureRollout;

/**
 * @generated from rpc nodebase.v1.AdminService.AdminSetWorkspaceFeatureOverride
 */
export const adminSetWorkspaceFeatureOverride = AdminService.method.adminSetWorkspaceFeatureOverride;

/**
 * @generated from rpc nodebase.v1.AdminService.AdminListFeatureAudit
 */
export const adminListFeatureAudit = AdminService.method.adminListFeatureAudit;

/**
 * @generated from rpc nodebase.v1.AdminService.AdminListWorkers
 */
export const adminListWorkers = AdminService.method.adminListWorkers;

/**
 * @generated from rpc nodebase.v1.AdminService.AdminListDevices
 */
export const adminListDevices = AdminService.method.adminListDevices;

/**
 * @generated from rpc nodebase.v1.AdminService.AdminSetDevicePrivateLaneCount
 */
export const adminSetDevicePrivateLaneCount = AdminService.method.adminSetDevicePrivateLaneCount;

/**
 * Invites gate account creation. They are on the admin surface rather than a
 * host-only subcommand because this surface already has the thing that was
 * missing when the CLI was the only option: an authenticated notion of who
 * an operator is.
 *
 * @generated from rpc nodebase.v1.AdminService.AdminCreateInvites
 */
export const adminCreateInvites = AdminService.method.adminCreateInvites;

/**
 * @generated from rpc nodebase.v1.AdminService.AdminListInvites
 */
export const adminListInvites = AdminService.method.adminListInvites;

/**
 * Queue a durable native VM CPU/memory change; existing disks are retained.
 *
 * @generated from rpc nodebase.v1.AdminService.AdminSetWorkerTier
 */
export const adminSetWorkerTier = AdminService.method.adminSetWorkerTier;

/**
 * AdminSetWorkerSpec resizes a legacy container worker's capacity in place — no rebuild, no
 * restart, running sessions survive. The floor is the Lite Worker baseline:
 * below it the agent and a usable shell do not fit, so a smaller figure is a
 * mistake, not a plan.
 *
 * @generated from rpc nodebase.v1.AdminService.AdminSetWorkerSpec
 */
export const adminSetWorkerSpec = AdminService.method.adminSetWorkerSpec;

/**
 * Assigns a workspace's outbound traffic to an exit IP, or clears it.
 * Several workspaces may share one assigned IP. Native VM source rules
 * update live for new connections; a container may need a rebuild to
 * acquire the binding's reserved source address.
 *
 * @generated from rpc nodebase.v1.AdminService.AdminSetExitBinding
 */
export const adminSetExitBinding = AdminService.method.adminSetExitBinding;

/**
 * AdminTrafficStats is the operator traffic view: per-workspace Worker and
 * Managed Edge Exit ledgers, plus global anonymous routing signals. Account
 * filters never apply to the latter — see ReportTraffic in worker.proto for
 * the privacy contract.
 *
 * @generated from rpc nodebase.v1.AdminService.AdminTrafficStats
 */
export const adminTrafficStats = AdminService.method.adminTrafficStats;

/**
 * Edge nodes are operator infrastructure. Create returns a one-time
 * bootstrap token; assignments are explicit canaries until automatic
 * capacity scheduling is proven in M2.
 *
 * @generated from rpc nodebase.v1.AdminService.AdminCreateEdge
 */
export const adminCreateEdge = AdminService.method.adminCreateEdge;

/**
 * @generated from rpc nodebase.v1.AdminService.AdminListEdges
 */
export const adminListEdges = AdminService.method.adminListEdges;

/**
 * @generated from rpc nodebase.v1.AdminService.AdminSetEdgeAssignment
 */
export const adminSetEdgeAssignment = AdminService.method.adminSetEdgeAssignment;

/**
 * @generated from rpc nodebase.v1.AdminService.AdminSetEdgeRoles
 */
export const adminSetEdgeRoles = AdminService.method.adminSetEdgeRoles;

/**
 * @generated from rpc nodebase.v1.AdminService.AdminSetEdgeEndpoints
 */
export const adminSetEdgeEndpoints = AdminService.method.adminSetEdgeEndpoints;

/**
 * @generated from rpc nodebase.v1.AdminService.AdminSetEdgeCapacity
 */
export const adminSetEdgeCapacity = AdminService.method.adminSetEdgeCapacity;

/**
 * @generated from rpc nodebase.v1.AdminService.AdminSetWorkspaceEntitlement
 */
export const adminSetWorkspaceEntitlement = AdminService.method.adminSetWorkspaceEntitlement;

/**
 * @generated from rpc nodebase.v1.AdminService.AdminRevokeEdge
 */
export const adminRevokeEdge = AdminService.method.adminRevokeEdge;
